// Carta import adapter — PSD §10.1 (F10.1). Integration layer.

import type { CapTable } from '@backsolve/shared-types';
import { ulid } from '@/id';
import { parseJsonOrCsv, buildInstrument, type CsvRow } from './_shared';

export interface ParsedImport {
  capTable: CapTable;
  warnings: string[];
}

export function parseCartaImport(file: string, entityName: string): ParsedImport {
  const rows = parseJsonOrCsv(file);
  const instruments = rows.map((row: CsvRow) =>
    buildInstrument(row, {
      name: ['stakeholder name', 'holder', 'name'],
      kind: ['security type', 'type', 'instrument type'],
      shares: ['quantity', 'shares', 'outstanding'],
      authorized: ['authorized', 'quantity', 'shares'],
      issuePrice: ['issue price', 'purchase price'],
      issueDate: ['issue date', 'date'],
      liquidationMultiple: ['liquidation multiple'],
      strikePrice: ['strike price', 'exercise price'],
    }),
  );
  return {
    capTable: {
      id: `cap_${ulid()}`,
      entityName,
      asOfDate: new Date().toISOString().slice(0, 10),
      instruments,
      convertibles: [],
      currency: 'USD',
      version: 1,
    },
    warnings: [],
  };
}

export async function parseImport(file: File, entityName: string): Promise<ParsedImport> {
  return parseCartaImport(await file.text(), entityName);
}
